import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles(theme => ({
  item: {
    "font-size": theme.fontSize,
    color: theme.textColor,
    padding: theme.spacing2,
    cursor: "pointer",
    "&:hover": {
      background: "#000",
    },
  },
}));

const ContextMenuItem = ({ children, onClick }) => {
  const classes = useStyles();

  return (
    <div className={classes.item} onClick={onClick} role="button">
      {children}
    </div>
  );
};

export default ContextMenuItem;
